import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { BaseAbstractModal } from '../base.abstract.modal';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-otp-modal',
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule],
  template: `
    <div class="alert-wrapper">
      <div class="alert-head">
        <h2>Подтверждение</h2>
        <p>Введите код из СМС</p>
      </div>

      <div class="alert-input-group">
        <ion-input-otp [length]="length" [(ngModel)]="otp"> </ion-input-otp>
      </div>

      <div class="alert-button-group">
        <ion-button fill="clear" (click)="cancel()">Cancel</ion-button>
        <ion-button fill="clear" (click)="confirm()" [disabled]="disabled()">
          Confirm
        </ion-button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        --backdrop-opacity: 0.4;
      }

      .alert-wrapper {
        background: var(--ion-overlay-background-color, #fff);
        width: 280px;
        border-radius: 13px;
        padding: 20px 10px 5px 10px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        text-align: center;
      }

      h2 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }

      p {
        margin: 5px 0 15px;
        font-size: 14px;
        color: #666;
      }

      ion-input-otp {
        --column-gap: 6px;
        margin-bottom: 15px;
      }

      .alert-button-group {
        display: flex;
        justify-content: space-around;
        border-top: 0.5px solid rgba(0, 0, 0, 0.1);
        margin-top: 10px;
      }

      ion-button {
        --color: var(--ion-color-primary);
        font-weight: 600;
      }
    `
  ]
})
export class OtpModalComponent extends BaseAbstractModal {
  @Input() length: number = 4;
  public otp: string = '';

  constructor() {
    super();
  }

  disabled() {
    return this.otp.length < this.length;
  }

  async cancel() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  async confirm() {
    await this.modalCtrl.dismiss(this.otp, 'confirm');
  }
}
